import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ChatService } from 'src/core/index/services.index';
import { DocumentSection } from 'src/index';

@Injectable({
    providedIn: 'root'
})
export class ChatServiceCustom extends ChatService {
    translateService = inject(TranslateService);
    
    override getTitle(): string {
        return "Code of Conduct";
    }

    override getCodeOfConductText(): DocumentSection[] {
        if (this.translateService.currentLang === 'en') {
			return [
				{
					type: 'text',
					title: 'Our Pledge',
					text: `<p class="mb-2">We as members, contributors, and leaders pledge to make participation in our community a harassment-free experience for everyone, regardless of age, body size, visible or invisible disability, ethnicity, sex characteristics, gender identity and expression, level of experience, education, socio-economic status, nationality, personal appearance, race, religion, or sexual identity and orientation.</p>
						<p class="mb-2">We pledge to act and interact in ways that contribute to an open, welcoming, diverse, inclusive, and healthy community.</p>`
				},
				{
					type: 'text',
					title: 'Our Standards',
					text: 'Examples of behavior that contributes to a positive environment for our community include:'
				},
				{
					type: 'list',
					symbol: 'dot',
					list: [
						{ text: 'Demonstrating empathy and kindness toward other people' },
						{ text: 'Being respectful of differing opinions, viewpoints, and experiences' },
						{ text: 'Giving and gracefully accepting constructive feedback' },
						{ text: 'Accepting responsibility and apologizing to those affected by our mistakes, and learning from the experience' },
						{ text: 'Focusing on what is best not just for us as individuals, but for the overall community' }
					]
				},
				{
					type: 'text',
					text: 'Examples of unacceptable behavior include:'
				},
				{
					type: 'list',
					symbol: 'dot',
					list: [
						{ text: 'The use of sexualized language or imagery, and sexual attention or advances of any kind' },
						{ text: 'Trolling, insulting or derogatory comments, and personal or political attacks' },
						{ text: 'Public or private harassment' },
						{ text: 'Publishing others\' private information, such as a physical or email address, without their explicit permission' },
						{ text: 'Other conduct which could reasonably be considered inappropriate in a professional setting' }
					]
				},
				{
					type: 'text',
					title: 'Enforcement Responsibilities',
					text: 'Community leaders are responsible for clarifying and enforcing our standards of acceptable behavior and will take appropriate and fair corrective action in response to any behavior that they deem inappropriate, threatening, offensive, or harmful.\n\nCommunity leaders have the right and responsibility to remove, edit, or reject comments, commits, code, wiki edits, issues, and other contributions that are not aligned to this Code of Conduct, and will communicate reasons for moderation decisions when appropriate.'
				},
				{
					type: 'text',
					title: 'Scope',
					text: 'This Code of Conduct applies within all community spaces, and also applies when an individual is officially representing the community in public spaces. Examples of representing our community include using an official e-mail address, posting via an official social media account, or acting as an appointed representative at an online or offline event.'
				},
				{
					type: 'text',
					title: 'Enforcement',
					text: `<p class="mb-2">Instances of abusive, harassing, or otherwise unacceptable behavior may be reported to the community leaders responsible for enforcement at <a class="text-primary underline hover:text-secondary" href="mailto:sonja.filiposka@finki.ukim.mk" target="_blank">sonja.filiposka@finki.ukim.mk</a>. All complaints will be reviewed and investigated promptly and fairly.</p>
						<p class="mb-2">All community leaders are obligated to respect the privacy and security of the reporter of any incident.</p>`
				},
				{
					type: 'list',
					title: 'Enforcement Guidelines',
					description: 'Community leaders will follow these Community Impact Guidelines in determining the consequences for any action they deem in violation of this Code of Conduct:',
					symbol: 'index',
					list: [{
						title: 'Correction',
						text: `<p class="mb-2"><strong>Community Impact</strong>: Use of inappropriate language or other behavior deemed unprofessional or unwelcome in the community.</p>
							<p class="mb-2"><strong>Consequence</strong>: A private, written warning from community leaders, providing clarity around the nature of the violation and an explanation of why the behavior was inappropriate. A public apology may be requested.`
					}, {
						title: 'Warning',
						text: `<p class="mb-2"><strong>Community Impact</strong>: A violation through a single incident or series of actions.</p>
							<p class="mb-2"><strong>Consequence</strong>: A warning with consequences for continued behavior. No interaction with the people involved, including unsolicited interaction with those enforcing the Code of Conduct, for a specified period of time. This includes avoiding interactions in community spaces as well as external channels like social media. Violating these terms may lead to a temporary or permanent ban.</p>`
					}, {
						title: 'Temporary Ban',
						text: `<p class="mb-2"><strong>Community Impact</strong>: A serious violation of community standards, including sustained inappropriate behavior.</p>
							<p class="mb-2"><strong>Consequence</strong>: A temporary ban from any sort of interaction or public communication with the community for a specified period of time. No public or private interaction with the people involved, including unsolicited interaction with those enforcing the Code of Conduct, is allowed during this period. Violating these terms may lead to a permanent ban.</p>`
					}, {
						title: 'Permanent Ban',
						text: `<p class="mb-2"><strong>Community Impact</strong>: Demonstrating a pattern of violation of community standards, including sustained inappropriate behavior,  harassment of an individual, or aggression toward or disparagement of classes of individuals.</p>
							<p class="mb-2"><strong>Consequence</strong>: A permanent ban from any sort of public interaction within the community.</p>`
					},]
				}, {
					type: 'text',
					title: 'Attribution',
					text: `<p class="mb-2">This Code of Conduct is adapted from the <a class="text-primary underline hover:text-secondary" href="https://www.contributor-covenant.org/" targe="_blank">Contributor Covenant</a>, version 2.0, available at <a class="text-primary underline hover:text-secondary" href="https://www.contributor-covenant.org/version/2/0/code_of_conduct.html" target="_blank">https://www.contributor-covenant.org/version/2/0/code_of_conduct.html</a>.</p>
						<p class="mb-2">Community Impact Guidelines were inspired by <a class="text-primary underline hover:text-secondary" href="https://github.com/mozilla/diversity" target="_blank">Mozilla's code of conduct enforcement ladder</a>.</p>
						<p class="mb-2">For answers to common questions about this code of conduct, see the FAQ at <a class="text-primary underline hover:text-secondary" href="https://www.contributor-covenant.org/faq" target="_blank">https://www.contributor-covenant.org/faq</a>. 
						Translations are available at <a class="text-primary underline hover:text-secondary" href="https://www.contributor-covenant.org/translations" target="_blank">https://www.contributor-covenant.org/translations</a>.</p>`
				}
	
			];
        }
		return [
			{
				type: 'text',
				title: 'Il nostro impegno',
				text: `<p class="mb-2">In quanto membri, contributori, e responsabili ci impegniamo a rendere la partecipazione nella nostra comunità un’esperienza priva di molestie per tutti, indipendentemente da età, corporatura, disabilità visibili o invisbili, etnia, sesso, identità ed espressioni di genere, livello di esperienza, istruzione, stato socio-economico, nazionalità, aspetto, razza, religione o orientamento sessuale.</p>
					<p class="mb-2">Ci impegniamo a creare e interagire in modo da contribuire ad una comunità aperta, accogliente, diversificata, inclusiva e sana.</p>`
			},{
				type: 'text',
				title: 'I nostri standard ',
				text: 'Esempi di comportamenti che contribuiscono ad un ambiente positivo per la nostra comunità includono:'
			},
			{
				type: 'list',
				symbol: 'dot',
				list: [
					{ text: 'Empatia e gentilezza verso gli altri' },
					{ text: 'Essere rispettosi delle opinioni, punti di vista ed esperienze altrui' },
					{ text: 'Dare e ricevere, con gentilezza, critiche costruttive' },
					{ text: 'Prendersi la responsabilità e scusarsi per i propri errori, cercando di imparare da essi' },
					{ text: 'Concentrarsi su ciò che è meglio per l’intera comunità e non solo per noi stessi come individui' }
				]
			},
			{
				type: 'text',
				text: 'Esempi di comportamenti inaccettabili includono:'
			},
			{
				type: 'list',
				symbol: 'dot',
				list: [
					{ text: 'Uso di linguaggio sessualizzante e attenzioni o approcci sessuali indesiderati' },
					{ text: 'Prendere in giro, insultare, commenti sprezzanti, e attacchi di natura personale o politica' },
					{ text: 'Molestie in pubblico o in privato' },
					{ text: 'Pubblicare informazioni private altrui, come un indirizzo postale o elettronico, senza il consenso esplicito' },
					{ text: 'Ogni altro comportamento che potrebbe essere considerato non appropriato in un ambiente professionale' }
				]
			},
			{
				type: 'text',
				title: 'Responsabilità e Adempimento',
				text: 'Coloro alla guida della community sono responsabili di chiarire e far rispettare i nostri standard in termini di appropriatezza e adotteranno azioni correttive contro ogni tipo di comportamento che riterranno inappropriato, minaccioso, offensivo o pericoloso. I leader della community hanno il diritto e la responsabilità di rimuovere, modificare o cancellare ogni tipo di commento, commit, codice, aggiornamenti delle pagine wiki, problemi, e tutto ciò che non è in linea con questo Codice di Condotta, e comunicheranno inoltre i motivi di tale decisione di moderazione ove e quando possibile.'
			},
			{
				type: 'text',
				title: 'Ambito',
				text: `Il presente Codice di condotta si applica ad ogni spazio della community, ed inoltre ad ogni individuo che la rappresenta in ambito pubblico. Esempi di rappresentazione della nostra community includono l’uso dell'indirizzo email ufficiale, pubblicazioni tramite account ufficiale, o rappresentanza ad un evento che sia online o offline.`
			},
			{
				type: 'text',
				title: 'Applicazione',
				text: `<p class="mb-2">Casi di comportamento abusivo, molesto o in ogni modo inaccettabile possono essere segnalati ai responsabili dell’attuazione di questo codice etico all’indirizzo <a href="mailto:training@h2iosc.cnr.it">training@h2iosc.cnr.it</a>. Ogni tipo di reclamo sarà esaminato e indagato prontamente ed equamente.</p>
					<p class="mb-2">Tutti i responsabili della comunità sono obbligati a rispettare la privacy e la sicurezza della persona che ha riportato il caso.</p>`
			},
			{
				type: 'list',
				title: 'Linee guida per l’applicazione',
				description: 'I responsabili della comunità si atterranno alle presenti Linee guida nel determinare le conseguenze di qualsiasi azione che ritengano in violazione del presente Codice di condotta:',
				symbol: 'index',
				list: [{
					title: 'Correzione',
					text: `<p class="mb-2"><strong>Impatto nella comunità</strong>: Uso di un linguaggio inappropriato o di altri comportamenti ritenuti non professionali o non graditi alla comunità.</p>
						<p class="mb-2"><strong>Conseguenze</strong>: Un ammonimento privato e scritto da parte dei responsabili della comunità, che chiarisca la natura della violazione e spieghi perché il comportamento è stato inappropriato. Possono essere richieste scuse pubbliche.`
				}, {
					title: 'Avvertimento',
					text: `<p class="mb-2"><strong>Impatto nella comunità</strong>: Una violazione attraverso un singolo incidente o una serie di azioni.</p>
						<p class="mb-2"><strong>Conseguenze</strong>: Un avvertimento con conseguenze in caso di comportamento continuato. Nessuna interazione con le persone coinvolte, compresa l'interazione con chi applica il Codice di condotta, per un determinato periodo di tempo. Ciò include l'evitare interazioni negli spazi della comunità e nei canali esterni quali  i social media. La violazione di questi termini può comportare un’espulsione temporanea o permanente.</p>`
				}, {
					title: 'Espulsione temporanea ',
					text: `<p class="mb-2"><strong>Impatto nella comunità</strong>: Una grave violazione degli standard comunitari, compreso un comportamento inappropriato prolungato.</p>
						<p class="mb-2"><strong>Conseguenze</strong>: Espulsione temporanea da qualsiasi tipo di interazione o comunicazione con la comunità per un determinato periodo di tempo. Durante questo periodo non è consentita alcuna interazione pubblica o privata con le persone coinvolte, compreso chi fa rispettare il Codice di condotta. La violazione di questi termini può portare ad una espulsione permanente.</p>`
				}, {
					title: 'Espulsione permanente',
					text: `<p class="mb-2"><strong>Impatto nella comunità</strong>: Dimostrare ripetutamente di violare gli standard comunitari, tra cui un comportamento inappropriato prolungato, molestie, aggressioni o denigrazioni individuali o di gruppo.</p>
						<p class="mb-2"><strong>Conseguenze</strong>: Espulsione permanente da qualsiasi tipo di interazione pubblica all'interno della comunità.</p>`
				},]
			}, {
				type: 'text',
				title: 'Attribuzione',
				text: `<p class="mb-2">Il seguente Codice di condotta è adattato dal <a class="text-primary underline hover:text-secondary" href="https://www.contributor-covenant.org/" targe="_blank">Contributor Covenant</a>, versione 2.0, disponibile su <a class="text-primary underline hover:text-secondary" href="https://www.contributor-covenant.org/version/2/0/code_of_conduct.html" target="_blank">https://www.contributor-covenant.org/version/2/0/code_of_conduct.html</a>.</p>
					<p class="mb-2">Le linee guida per l'impatto sulla comunità sono state ispirate dal <a class="text-primary underline hover:text-secondary" href="https://github.com/mozilla/diversity" target="_blank">Mozilla's code of conduct enforcement ladder</a>.</p>
					<p class="mb-2">Per le risposte alle domande più comuni su questo codice di condotta, consultare le domande frequenti all'indirizzo <a class="text-primary underline hover:text-secondary" href="https://www.contributor-covenant.org/faq" target="_blank">https://www.contributor-covenant.org/faq</a>. 
					Traduzioni disponibili su <a class="text-primary underline hover:text-secondary" href="https://www.contributor-covenant.org/translations" target="_blank">https://www.contributor-covenant.org/translations</a>.</p>`
			}
		];
    }

}